<template>
  <div class="container-box">
    <MediaHeader />

    <div class="search-box-1 mb-n3 pb-5">
      <div></div>
      <div class="btn">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click.prevent="showModal = true"
        >
          <v-icon left> mdi-plus </v-icon>
          코스 등록
        </v-btn>
      </div>
    </div>

    <p class="text-total-1 mb-3">
      총 <strong>{{ customBoardLists.length || 0 }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap" style="position: relative">
      <v-data-table
        :headers="boardHeaders"
        :items="customBoardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.courses`]="{ item }">
          {{ `${item.courses[0].name} 외 ${item.courses.length - 1}개` }}
        </template>

        <template v-slot:[`item.create_at`]="{ item }">
          {{ item.create_at | moment('YYYY.MM.DD HH:mm:ss') }}
        </template>

        <template v-slot:[`item.is_valid`]="{ item }">
          <v-switch
            inset
            hide-details
            color="#fecd00"
            :input-value="item.is_valid === 'Y' ? true : false"
            :label="item.is_valid === 'Y' ? 'ON' : 'OFF'"
            class="switch-type-1 mt-0"
            @change="isValidPopup(item)"
          ></v-switch>
        </template>

        <template v-slot:[`item.modify`]="{ item }">
          <a
            href=""
            @click.prevent="modifyModal(item)"
            style="color: transparent"
          >
            <v-icon color="#fecd00">mdi-cog-outline</v-icon>
          </a>
        </template>

        <template v-slot:no-data>
          <div class="text-center">
            등록된 코스가 없습니다. 우측상단 코스등록 버튼을 클릭후 코스를
            추가해주세요.
          </div>
        </template>
      </v-data-table>
    </div>
    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>
    </div>

    <!-- Modal -->
    <v-dialog
      persistent
      v-model="showModal"
      width="564"
      content-class="popup-wrap-1"
    >
      <div class="pa-9">
        <p class="title-type-4">코스 관리</p>
        <v-form ref="form">
          <div class="form-row-1">
            <p class="label">
              그룹명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                placeholder="20자 이내로 입력해주세요."
                class="input-custom-2"
                height="40px"
                v-model="modalGroup.name"
                :rules="nameRules"
                solo
              ></v-text-field>
            </div>
          </div>

          <div class="form-row-1 mt-6">
            <p class="label">
              코스
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="relative write-con">
              <v-text-field
                placeholder="코스를 선택해주세요."
                class="input-custom-2"
                height="40px"
                hide-details
                readonly
                solo
                @click="showCourseList = true"
              ></v-text-field>
              <v-chip-group column>
                <v-chip v-for="(course, idx) in modalGroup.courses" :key="idx"
                  >{{ course.name }}
                  <v-icon small @click="selectCourse(course)">$delete</v-icon>
                </v-chip>
              </v-chip-group>
              <v-dialog
                v-model="showCourseList"
                persistent
                width="464"
                content-class="popup-wrap-1"
              >
                <div class="pa-1">
                  <v-text-field
                    ref="search"
                    v-model="search"
                    class="pl-5 pr-5"
                    full-width
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    label="검색"
                    single-line
                  ></v-text-field>
                  <v-divider></v-divider>
                  <v-list height="300" style="overflow-y: scroll">
                    <v-list-item-group multiple>
                      <v-list-item
                        v-for="course in searchCourseList"
                        :key="course.id"
                        @click="selectCourse(course)"
                        :inactive="true"
                      >
                        <v-list-item-title>{{ course.name }}</v-list-item-title>
                        <v-icon v-if="selectedCourses.has(course.id)"
                          >mdi-check</v-icon
                        >
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <v-btn
                    large
                    depressed
                    max-height="40px"
                    min-width="456px"
                    color="#fecd06"
                    class="button-type-2 mt-2"
                    @click="showCourseList = false"
                    >선택완료</v-btn
                  >
                </div>
              </v-dialog>
            </div>
          </div>

          <div class="form-row-1 mt-6">
            <p class="label">
              노출 관리
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-radio-group v-model="modalGroup.is_valid" class="mt-0" row>
                <v-radio
                  label="ON"
                  value="Y"
                  color="#fecd00"
                  class="radio-type-1"
                ></v-radio>
                <v-radio
                  label="OFF"
                  value="N"
                  color="#fecd00"
                  class="radio-type-1 ml-2"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-form>

        <div class="d-flex justify-end mt-6">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fff"
            class="button-type-2"
            @click.stop="modalCancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click.prevent="registerCourse"
            :disabled="
              !modalGroup.name ||
              !modalGroup.courses.length ||
              !modalGroup.is_valid
            "
          >
            저장
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- Modal -->

    <SystemAlert v-model="showSystemAlert" :persistent="true">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import {
  listCourse,
  listCourseGroup,
  createCourseGroup,
  updateCourseGroup,
} from '@/api/courses';
import _ from 'lodash';

import SystemAlert from '~@/modal/SystemAlert';
import MediaHeader from '@/views/media/header';

export default {
  components: { MediaHeader, SystemAlert },
  computed: {
    customBoardLists() {
      this.boardLists.forEach((item, index) => {
        item.no = this.boardLists.length - index;
        item.modify = '수정';
      });
      return this.boardLists;
    },
    clearModalGroup() {
      return {
        name: '',
        is_valid: '',
        courses: [],
      };
    },
    searchCourseList() {
      if (!this.search) return this.courseList;

      const search = this.search.toLowerCase();
      if (!search) return this.courseList;

      return this.courseList.filter(course => {
        const name = course.name.toLowerCase();
        return name.indexOf(search) > -1;
      });
    },
  },
  data: () => ({
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      { text: 'No', value: 'no', width: '8%', sortable: false },
      { text: '그룹명', value: 'name', width: '15%', sortable: false },
      { text: '코스', value: 'courses', width: '20%', sortable: false },
      { text: '등록일', value: 'create_at', width: '14%', sortable: false },
      {
        text: '등록 관리자',
        value: 'creator.manager_name',
        width: '18%',
        sortable: false,
      },
      { text: '노출관리', value: 'is_valid', width: '18%', sortable: false },
      { text: '관리', value: 'modify', width: '8%', sortable: false },
    ],
    boardLists: [],
    modalGroup: { name: null, courses: [], is_valid: null },
    nameRules: [
      v => !!v || '코스명을 입력해주세요.',
      v =>
        (v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글, 영문, 숫자만 입력 가능합니다.',
      v => (v && v.length <= 20) || '최대 20자 이내로 입력해주세요.',
    ],
    resultType: '',
    logResult: '',
    showModal: false,
    showSystemAlert: false,

    showCourseList: false,
    coursesSize: { min: 2, max: 15 },
    selectedCourses: new Set(),
    courseList: [],
    search: '',
  }),
  methods: {
    async getListCourse() {
      const { data } = await listCourse();
      const courseList = data.list.filter(c => c.is_valid === 'Y');

      this.courseList = _.sortBy(courseList, ['name']);
    },
    async getListCourseGroup() {
      try {
        const { data } = await listCourseGroup();
        this.boardLists = data.list.reverse();
      } finally {
        bus.$emit('end:spinner');
      }
    },
    async registerCourse() {
      const validate = this.$refs.form.validate();
      if (!validate) {
        this.logResult = '필수 값이 입력되지 않았습니다.';
      } else if (this.selectedCourses.size < this.coursesSize.min) {
        this.logResult = `코스를 ${this.coursesSize.min}개 이상 선택해주세요.`;
      } else if (this.selectedCourses.size > this.coursesSize.max) {
        this.logResult = `그룹 CC 코스 1개당 ${this.coursesSize.max}개 CC만 등록 가능합니다.`;
      }

      if (this.logResult) {
        this.showSystemAlert = true;
        return;
      }

      bus.$emit('start:spinner');
      try {
        const param = {
          name: this.modalGroup.name.trim(),
          is_valid: this.modalGroup.is_valid,
          courses: this.modalGroup.courses.map(c => c.id),
        };
        const { data } = this.modalGroup.id
          ? await updateCourseGroup(this.modalGroup.id, param)
          : await createCourseGroup(param);

        if (data.result === 'success') {
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = `그룹이 ${
            this.modalGroup.id ? '수정' : '등록'
          } 되었습니다.`;
        }
      } catch (error) {
        const { data } = error.response;
        this.resultType = data.result;

        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 그룹명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }
      } finally {
        this.$refs.form.reset();
        this.modalGroup = this.clearModalGroup;
        bus.$emit('end:spinner');
      }
    },
    async closePopup() {
      this.showSystemAlert = false;
      this.logResult = '';
      if (this.resultType === 'success') {
        bus.$emit('start:spinner');

        this.modalCancel();
        await this.getListCourseGroup();
      }
    },
    modifyModal(group) {
      this.modalGroup = _.cloneDeep(group);
      this.selectedCourses = new Set(this.modalGroup.courses.map(c => c.id));
      this.showModal = true;
    },
    async isValidPopup(group) {
      bus.$emit('start:spinner');
      try {
        const param = {
          name: group.name.trim(),
          is_valid: group.is_valid === 'Y' ? 'N' : 'Y',
          courses: group.courses.map(c => c.id),
        };
        const { data } = await updateCourseGroup(group.id, param);
        if (data.result === 'success') {
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = '노출 설정을 변경하였습니다.';
        }
      } catch (error) {
        const { data } = error.response;
        this.resultType = data.result;

        this.showSystemAlert = true;
        if (data.result === 'DuplicatedEntry') {
          this.logResult = '이미 사용중인 그룹명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }
      } finally {
        bus.$emit('end:spinner');
      }
    },
    modalCancel() {
      if (this.$refs.form) this.$refs.form.reset();

      this.modalGroup = this.clearModalGroup;
      this.selectedCourses = new Set();
      this.showModal = false;
    },
    selectCourse(course) {
      if (this.selectedCourses.has(course.id)) {
        const index = this.modalGroup.courses.findIndex(
          s => course.id === s.id,
        );
        this.modalGroup.courses.splice(index, 1);
        this.selectedCourses.delete(course.id);
      } else {
        if (this.selectedCourses.size >= this.coursesSize.max) {
          this.logResult = `그룹 CC 코스 1개당 ${this.coursesSize.max}개 CC만 등록 가능합니다.`;
          this.showSystemAlert = true;
          return;
        }

        this.modalGroup.courses.push(course);
        this.selectedCourses.add(course.id);
      }
    },
  },
  async created() {
    bus.$emit('start:spinner');

    this.modalGroup = this.clearModalGroup;
    await this.getListCourseGroup();
    await this.getListCourse();
  },
};
</script>
